import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    errorMessage: '',
    aftercareRequest: undefined,
};
export default createSlice({
    name: 'orders',
    initialState: initialState,
    reducers: {
        clearErrors: (state) => {
            state.errorMessage = '';
        },
        updateAftercareRequest: (state, action) => {
            state.aftercareRequest = Object.assign(Object.assign({}, state.aftercareRequest), action.payload);
        },
        setErrorMessage: (state, action) => {
            console.log('Setting error message to ' + action.payload);
            state.errorMessage = action.payload;
        },
    },
});
